import { CheckCircle } from "@mui/icons-material";
import { Box, Chip, Paper, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setClient } from "../../../../redux/features/jobCreateSlice";
import { alphaVar, colors } from "../../../ui/colors";
import { listCoverageAreas } from "../helper/resolvePreferredCoverageArea";

function formatAddress(area: { address?: string; city?: string; state?: string; zipCode?: string }) {
  return [area.address, area.city, area.state, area.zipCode].filter(Boolean).join(", ");
}

export function SelectClientAddressStep() {
  const dispatch = useDispatch();
  const client = useSelector((state: any) => state.jobCreateStepper.client);
  const areas = listCoverageAreas(client);
  const selectedId = client && typeof client === "object" ? client.coverageArea?.id : null;

  const handleSelect = (area: (typeof areas)[number]) => {
    if (!client || typeof client !== "object") return;
    dispatch(setClient({ ...client, coverageArea: area }));
  };

  return (
    <Box sx={{ maxWidth: 720, mx: "auto", pt: { xs: 2, md: 4 }, px: 2 }}>
      <Typography sx={{ fontWeight: 800, fontSize: { xs: 24, md: 32 }, color: "var(--fx-surface-text, #0F172A)", mb: 1 }}>
        Choose an address
      </Typography>
      <Typography sx={{ color: "var(--fx-surface-textsecondary, #64748B)", mb: 3 }}>
        This client has more than one address. Pick the one for this job.
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
        {areas.map((area) => {
          const selected = selectedId != null && String(selectedId) === String(area.id);
          const label = area.name || area.address || "Address";
          const details = formatAddress(area);

          return (
            <Paper
              key={area.id}
              elevation={0}
              onClick={() => handleSelect(area)}
              sx={{
                p: 2,
                borderRadius: 2,
                cursor: "pointer",
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                gap: 2,
                border: `1px solid ${selected ? colors.orange.base : "var(--fx-surface-border, #E2E8F0)"}`,
                bgcolor: selected ? alphaVar(colors.orange.base, 0.06) : "var(--fx-surface-base, #FFFFFF)",
                "&:hover": {
                  borderColor: colors.orange.base,
                },
              }}
            >
              <Box sx={{ minWidth: 0 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5, flexWrap: "wrap" }}>
                  <Typography sx={{ fontWeight: 700, color: "var(--fx-surface-text, #0F172A)" }}>{label}</Typography>
                  {area.isDefault ? <Chip size="small" label="Default" sx={{ height: 22, fontWeight: 700 }} /> : null}
                </Box>
                {details && details !== label ? (
                  <Typography sx={{ color: "var(--fx-surface-textsecondary, #64748B)", fontSize: 14 }}>{details}</Typography>
                ) : null}
              </Box>
              {selected ? <CheckCircle sx={{ color: colors.orange.base, mt: 0.25 }} /> : null}
            </Paper>
          );
        })}
      </Box>
    </Box>
  );
}
